import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";

import InvoicesDashboard from "./components/InvoicesDashboard";
import Loader from "../../components/elements/Loader";
import PageLayout from "../../layouts/PageLayout";
import api from "../../api";
import { ReduxApplicationState } from "../../types/ReduxTypes/ReduxApplicationState";

const InvoicesPage = () => {
  const [invoices, setInvoices] = useState<any[]>([]);
  const [isLoading, setIsLoading] = useState(false);

  const user = useSelector((state: ReduxApplicationState) => state.user);

  useEffect(() => {
    const fetchAndSetInvoices = async () => {
      try {
        setIsLoading(true);
        const fetchedInvoices = await api.getInvoices(user.currentUser);
        setInvoices(fetchedInvoices);
        setIsLoading(false);
      } catch (error) {
        console.log(`Error in fetchAndSetInvoices: ${error}`);
        setIsLoading(false);
      }
    };

    fetchAndSetInvoices();
  }, [user.currentUser]);

  return (
    <PageLayout heading={`${user.currentUser[0].toUpperCase() + user.currentUser.slice(1)} Invoices`} displayArrowBack>
      {isLoading ? <Loader /> : <InvoicesDashboard invoices={invoices} />}
    </PageLayout>
  );
};

export default InvoicesPage;
